<template>
<div>
    <p>
        <span>
            <strong>Category:</strong>
        </span>&nbsp;
        <b-badge :id="'category-tooltip-target-'+eventIndex+'-'+alertIndex" variant="primary">{{event.category || "Not Available"}}</b-badge>
    </p>
    <b-tooltip :target="'category-tooltip-target-'+eventIndex+'-'+alertIndex">{{getEventCategoryDescription(event.category)}}</b-tooltip>
    <p>
        <span>
            <strong>Description:</strong>
        </span>&nbsp;
        <span> {{ event.description || 'Not Available' }}</span>
    </p>
    <p>
        <span>
            <strong>Sub Category:</strong>
        </span>&nbsp;
        <b-badge variant="primary" :id="'subcategory-tooltip-target-'+eventIndex+'-'+alertIndex">{{event.subCategory || "Not Available"}}</b-badge>
    </p>
    <b-tooltip :target="'subcategory-tooltip-target-'+eventIndex+'-'+alertIndex">{{getEventSubCategoryDescription(event.subCategory)}}</b-tooltip>

    <div>
        <strong>Event Information</strong>
        <p><span>Name: </span><span>{{event.sourceItem && event.sourceItem.name || 'N/A'}}</span></p>
        <p><span>Url: </span><span>{{event.sourceItem && event.sourceItem.url || 'N/A'}}</span></p>
        <p><span>Date: </span><span>{{event.sourceItem && event.sourceItem.date || 'N/A'}}</span></p>

    </div>
    <hr v-if="alertIndex>0" />

</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import eventCategoryCode from "../../utils/remediationJson/eventCategoryCode.json";
import eventSubCategoryCode from "../../utils/remediationJson/eventSubCategoryCode.json";

import pepCode from "../../utils/remediationJson/pepCodes.json";
export default {
    name: "RDCAlertEvent",
    components: {

    },
    data() {
        return {

            alertCollapse: false,
            alertStatus: "pending",
            date: null,
            

            rdcDictionaryEventCategoryCode: eventCategoryCode.EventCategoryCode,
            rdcDictionaryEventSubCategoryCode: eventSubCategoryCode.EventSubCategoryCode,
            rdcDictionaryPepCodes: pepCode.PEPCodes,
          

            // for ctegories
            uniqueCategories: [],
            uniqueSubCategories: [],
            secUniqueCount: 0
        };
    },
    created() {},
    mounted() {
       
        this.alertStatus = "pending";
        
    },
    validations: {},
    computed: {
        ...mapGetters([]),
       
    },
    watch: {
       
    },
    methods: {
     
        getEventCategoryDescription(code) {

            let description;

            this.rdcDictionaryEventCategoryCode.map(event => {

                if (event.Code == code) {
                    description = event.Description
                }

            });
            return description;
        },
        getEventSubCategoryDescription(code) {

            let description;

            this.rdcDictionaryEventSubCategoryCode.map(event => {

                if (event.Code == code) {
                    description = event.Description
                }

            });
            return description;
        },
        

    },
    props: {
        event: Object,
        eventIndex: Number,
        alertIndex: Number
    }
};
</script>
